import { render, staticRenderFns } from "./RegisterForMass.vue?vue&type=template&id=00ddfc98&scoped=true&"
import script from "./RegisterForMass.vue?vue&type=script&lang=js&"
export * from "./RegisterForMass.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForMass.vue?vue&type=style&index=0&id=00ddfc98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ddfc98",
  null
  
)

export default component.exports